import { ProductType } from 'enums/product-type';
import ProductLoanDescription from './ProductLoanDescription';
import ProductFinanceDescription from './ProductFinanceDescription';
import ProductMerchantDescription from './ProductMerchantDescription';
import { Box } from '@capitalise/ui-design-system';
import PropTypes from 'prop-types';

const mapProductTypeToDescription = (props) => {
  return {
    [ProductType.termLoans]: <ProductLoanDescription {...props} />,
    [ProductType.assetBackedFinance]: <ProductLoanDescription {...props} />,
    [ProductType.commercialProperty]: <ProductLoanDescription {...props} />,
    [ProductType.recoveryLoanScheme]: <ProductLoanDescription {...props} />,
    [ProductType.invoiceFinancing]: <ProductFinanceDescription {...props} />,
    [ProductType.tradeFinance]: <ProductFinanceDescription {...props} />,
    [ProductType.merchantCashAdvance]: <ProductMerchantDescription {...props} />,
  };
};

const ProductDescription = ({ product, ...props }) => {
  return (
    <Box
      display={{ md: 'flex', _: 'grid' }}
      gridTemplateColumns="1fr 1fr 1fr 1fr"
      justifyContent="space-between"
      gridColumnGap="tiny"
      pt={{ md: '0', default: '3xsmall' }}
    >
      {mapProductTypeToDescription(props)[product]}
    </Box>
  );
};

ProductDescription.propTypes = {
  product: PropTypes.number,
};

export default ProductDescription;
